import type { GlossaryEntry } from "./glossary";

export const EXTRA_GLOSSARY: GlossaryEntry[] = [
  {
    id: "probability",
    term: "Probability",
    definition: "A number from 0 to 1 measuring how likely an outcome is, or how strongly the evidence supports a claim. Philosophers and statisticians disagree about what exactly it measures, but the arithmetic rules are shared.",
    example: "A fair coin has a probability of 0.5 of landing heads on any single toss.",
    related: ["uncertainty", "base-rate", "bayes", "induction"],
    seeAlso: [{ label: "Fallacy: Gambler's Fallacy", to: "/FallacyLibraryPage#fallacy-gamblers-fallacy" }],
    status: "logical",
    category: "science",
  },
  {
    id: "empirical",
    term: "Empirical",
    definition: "Based on observation, measurement or experiment rather than on reasoning alone.",
    example: "Measuring how quickly a satellite's orbit decays gives empirical data about atmospheric drag.",
    related: ["a-posteriori", "empiricism", "evidence", "hypothesis"],
    seeAlso: [{ label: "Evidence comparison", to: "/KnowledgeLaboratoryPage#evidence-comparison" }],
    status: "empirical",
    category: "science",
  },
  {
    id: "antecedent",
    term: "Antecedent",
    definition: "The 'if' part of a conditional statement. In 'If P then Q', P is the antecedent and Q is the consequent.",
    example: "In 'If the temperature drops below freezing, the puddle ices over', the antecedent is 'the temperature drops below freezing'.",
    related: ["conditional", "modus-ponens", "denying-the-antecedent", "affirming-the-consequent"],
    seeAlso: [{ label: "Argument tester", to: "/LogicLaboratoryPage#argument-tester" }],
    status: "logical",
    category: "logic",
  },
  {
    id: "bayes",
    term: "Bayes' Theorem",
    definition: "A rule for updating a probability when new evidence arrives: P(H|E) = P(E|H) × P(H) / P(E). It shows why the starting (base-rate) probability matters.",
    example: "Fictional numbers: if 1% of people have a condition, a test catches 90% of cases and wrongly flags 9% of healthy people, then a positive result means about a 9% chance of having it (0.009 / (0.009 + 0.0891)).",
    related: ["probability", "base-rate", "conditional-probability-confusion", "evidence"],
    seeAlso: [{ label: "Fallacy: Base-rate neglect", to: "/FallacyLibraryPage#fallacy-base-rate-neglect" }],
    status: "logical",
    category: "science",
  },
  {
    id: "fictional",
    term: "Fictional Assumption",
    definition: "An invented scenario or number used only to demonstrate an idea. It is not a claim about the real world.",
    example: "The pages on this site use made-up patients, towns and statistics to show how a calculation works.",
    related: ["assumption", "model"],
    status: "fictional",
    category: "reasoning",
  },
];
